import cookie from 'cookie';
import Cookies from 'js-cookie';
// import Cookies, { CookieAttributes } from 'js-cookie';

import { customToString } from './commonFunc';

const cookieParams = {};

/**
 * To Check User is LoggedIn or Not
 * @param reqCookies
 * @returns boolean
 */
export const isLoggedIn = (reqCookies = null) => {
    // if we don't have request cookies, get the cookie from client
    if (!reqCookies) {
        return !!Cookies.get('is_logged_in');
    }
    return !!cookie.parse(reqCookies).is_logged_in;
};

/**
 * Set Cookie Values
 * @param cookieName
 * @param cookieValue
 * @param isReload
 */
export const setCookie = (cookieName: string, cookieValue: string, isReload = false) => {
    Cookies.set(cookieName, cookieValue, cookieParams);
    if (isReload) {
        window.location.reload();
    }
};

/**
 * Get Cookie Values By Cookie Name
 * @param cookieName
 */
export const getCookie = (cookieName: string) => {
    if (!Cookies.get(cookieName)) {
        return null;
    }
    return JSON.parse(JSON.stringify(customToString(Cookies.get(cookieName))));
};

/**
 * Remove Cookie By Name
 * @param cookieName
 * @param isRedirect
 * @param redirectRoute
 */
export const removeCookie = (cookieName: string, isRedirect = false, redirectRoute = '') => {
    Cookies.remove(cookieName, cookieParams);
    if (isRedirect) {
        // router.push(redirectRoute);
        window.location.href = redirectRoute;
    }
};
